const types = {
  TYPE_PREPAID: "Prepaid",
  TYPE_POSTPAID: "Postpaid",
  TYPE_PREORDER: "Pre Order",
  TYPE_MONTHLY: "Monthly",
  TYPE_ONCE_OFF: "Once-off",
  TRACKING: "tracking",
  DETAILS: "details",
  PRICE_MIN_VALUE: 0,
  PRICE_MAX_VALUE: 100000,
  PRICE_MAX_VALUE_MONTHLY: 4000,
  PRICE_MAX_VALUE_ONCE_OF: 50000,
  DEAL_GRID_PAGE: "deals",
  TRACK_MY_ORDER_PAGE: "track-my-order",
  ORDER_DETAILS_PAGE: "view-order-details"
};
export default types;
